export const LoadingWrapper = () => {
  return (
    <div className="bluebook-tru-list-loading">
      <span className="bluebook-loading-anim"></span>
    </div>
  );
};
